import store from "./customers/reducers/store";
import { ON_LOAD_CONFIG } from "./customers/constants/config";
import { ON_LOAD_USER } from "./customers/constants/user";
import { ON_LOAD_NOTIFICATIONS } from "./customers/constants/notifications";
import { ON_LOAD_CAMPAIGN_DROP_DOWN } from "./customers/constants/campaignDropDown";
import { ON_LOAD_PAYMENTS } from "./customers/constants/payments";

const InitStore = data => {
  // Load all data in config
  // TODO: need remove exists params from it
  store.dispatch({
    type: ON_LOAD_CONFIG,
    payload: data
  });

  // Load user data
  store.dispatch({
    type: ON_LOAD_USER,
    payload: {
      ...data.USER,
      must_accept_offer: data.must_accept_offer,
      has_password: data.has_password
    }
  });

  // Load payment data
  store.dispatch({
    type: ON_LOAD_PAYMENTS,
    payload: data.payment
  });

  // Load notifications data
  store.dispatch({
    type: ON_LOAD_NOTIFICATIONS,
    payload: data.notifications
  });

  // Load campaignDropDown data
  store.dispatch({
    type: ON_LOAD_CAMPAIGN_DROP_DOWN,
    payload: data.campaignDropDown.campaigns
  });
};

export default InitStore;
